/**
 * 登录页
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import BackGround from './components/BackGround';
import LoginBox from './components/LoginBox';
import { Button, Modal } from 'antd';

class Login extends React.Component {
    render() {
        const type = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';
        return (
            <div className={styles.container}>
                <div className={type == 'ADMIN' ? styles.adminBg : styles.ocBg}></div>
                {type == 'ADMIN'
                    ? <div className={styles.adminMain}>
                        <div className={styles.logo}></div>
                        <div className={styles.title}>配送管理后台</div>
                        <LoginBox history={this.props.history} accountType={type} />
                    </div>
                    : <div className={styles.ocMain}>
                        <div className={styles.logo}></div>
                        <div className={styles.title}>运营公司后台</div>
                        <LoginBox history={this.props.history} accountType={type} />
                    </div>
                }

                <div className={styles.footer}>
                    <span>普惠空间（重庆）数字科技有限公司</span>
                    <a href="https://beian.miit.gov.cn/" target='_blank' rel='noreferrer'>渝ICP备2024040606号-1</a>
                    <span>客服电话：4008622123</span>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    history: PropTypes.object
};

export default Login;